var render, staticRenderFns
import script from "./get-signed-url.vue?vue&type=script&lang=ts"
export * from "./get-signed-url.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e272ec2",
  null
  
)

export default component.exports